import React, { useMemo } from "react";
import {
  Tabs,
  Tab,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
} from "@material-ui/core";
import { useCallback } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import TabPanel from "./components/TabPanel";
import GeneralTab from "./components/GeneralTab";
import GameTypeTab from "./components/GameTypeTab";
import StraightTab from "./components/StraightTab";
import ParlayTab from "./components/ParlayTab";
import SelectionsSimple from "../../common/SelectionsSimple";

const useStyles = makeStyles({
  paper: {
    width: "90vw !important",
    height: "90vh",
  },
});

const useStylesContent = makeStyles({
  root: {
    padding: "0px 16px",
  },
});

function ApplyToAll({ open, onClose, profile }) {
  const classes = useStyles();
  const classesContent = useStylesContent();

  const [tab, setTab] = React.useState(0);
  const handleTabChange = useCallback((_, value) => {
    setTab(value);
  }, []);

  const p = {};

  const profileApply = useMemo(
    () => ({
      PlayerProfileGameTypeSport: {
        WagerTypes: new Set(),
      },
      PlayerProfileStraightLimitFootball: {
        IdSports: new Set(),
      },
      PlayerProfileStraightLimitBasketball: {
        IdSports: new Set(),
      },
    }),
    []
  );

  /**
   * State
   */
  const handleProfilesSelected = useCallback(
    (IdProfiles) => {
      profileApply.IdProfiles = IdProfiles;
      profileApply.PlayerProfileGameTypeSport = {
        ...profileApply.PlayerProfileGameTypeSport,
        IdProfiles,
      };
      profileApply.PlayerProfileStraightLimitFootball = {
        ...profileApply.PlayerProfileStraightLimitFootball,
        IdProfiles,
      };
      profileApply.PlayerProfileStraightLimitBasketball = {
        ...profileApply.PlayerProfileStraightLimitBasketball,
        IdProfiles,
      };
      profileApply.GameRelatedOptions = {
        ...profileApply.GameRelatedOptions,
        IdProfiles,
      };
      profileApply.PlayerProfileGameType = {
        ...profileApply.PlayerProfileGameType,
        IdProfiles,
      };
      profileApply.PlayerProfileParlayLimit = {
        ...profileApply.PlayerProfileParlayLimit,
        IdProfiles,
      };
      profileApply.PlayerProfileParlayLimitDetail = {
        ...profileApply.PlayerProfileParlayLimitDetail,
        IdProfiles,
      };
      profileApply.PlayerProfileParlayBasicSports = {
        ...profileApply.PlayerProfileParlayBasicSports,
        IdProfiles,
      };
    },
    [profileApply]
  );

  /**
   * Actions
   */
  const handleApplyToAll = useCallback(() => {}, []);

  return (
    <Dialog open={open} onClose={onClose} classes={classes}>
      <DialogTitle>
        Copy Selected &quot;Profile Name&quot; values to all selected profiles
      </DialogTitle>
      <DialogContent classes={classesContent}>
        <div className="grid h-full grid-cols-4 gap-2">
          {/* Profiles List */}
          <SelectionsSimple
            className="!h-full simple-table"
            // GET
            itemKey="IdProfile"
            getUrl={"/Player/GetPlayerProfile"}
            getProcess={(data) =>
              data.filter(({ IdProfile }) => IdProfile !== profile.IdProfile)
            }
            // CHANGE
            onChanged={handleProfilesSelected}
          >
            <TableHeaderColumn
              visible="none"
              isKey={true}
              hidden
              dataField="IdProfile"
            >
              IdProfile
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="ProfileName"
              filter={{ type: "TextFilter" }}
            >
              Filter Profiles
            </TableHeaderColumn>
          </SelectionsSimple>
          {/* Tabs */}
          <div className="flex flex-col h-full min-h-0 col-span-3 overflow-hidden">
            <Tabs value={tab} onChange={handleTabChange} variant="fullWidth">
              <Tab label="General" id={0} />
              <Tab label="Game Type" id={1} />
              <Tab label="Straight" id={2} />
              <Tab label="Parlay" id={2} />
            </Tabs>
            <TabPanel value={tab} index={0}>
              <GeneralTab profile={profileApply} />
            </TabPanel>
            <TabPanel value={tab} index={1}>
              <GameTypeTab profile={profileApply} />
            </TabPanel>
            <TabPanel value={tab} index={2}>
              <StraightTab profile={profileApply} />
            </TabPanel>
            <TabPanel value={tab} index={3}>
              <ParlayTab profile={profileApply} />
            </TabPanel>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleApplyToAll} color="primary" variant="contained">
          Apply
        </Button>
        <Button
          onClick={() => onClose(false)}
          color="secondary"
          variant="contained"
          autoFocus
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ApplyToAll;
